export default __webpack_public_path__ + "3204c8b7789506ef7efe7aed1f5a970a.svg";